export const fieldValidation = {
  required: '{{fieldName}} は必須です',
  pattern: '{{fieldName}} は無効です',
  maxLength: '{{fieldName}} の字数制限は {{value}} です',
};
